<template>
	<div>
		<template v-if="!day.open">
			{{ stringaMultilingua('Chiuso', 'Closed', 'Geschlossen') }}
		</template>
		<template v-else-if="day.hours?.length">
			{{ formatHours(day.hours) }}
		</template>
		<template v-else>{{ stringaMultilingua('Aperto', 'Open', 'Offen') }}</template>
	</div>
</template>

<script setup>
	import {toRefs, computed} from 'vue'

	const props = defineProps({
		day: Object,
		formatHours: Function,
		locale: {
			type: String,
			default: 'it',
		},
	})
	const {day, formatHours, locale} = toRefs(props)
	const language = computed(() => locale.value.split('-')[0])

	function stringaMultilingua(...params) {
		switch (language.value) {
			case 'it':
				return params[0]
			case 'de':
				return params[2]
			default:
				// 2
				return params[1]
		}
	}
</script>
